import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/shadcn/card';

export default function SuperAdminBanners() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Manajemen Banner</CardTitle>
        <CardDescription>Upload dan kelola banner aktif</CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground">Fitur manajemen banner akan segera tersedia.</p>
      </CardContent>
    </Card>
  );
}
